import { useGetViewupSnsAccounts } from 'Shared/hooks/api';
import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { Analytics } from 'Shared/utils/client';
import { LINK } from '@constants';
import type { AllStyledProps } from '@viewup/ui';
import {
  AutoViewing,
  AutoViewingPictogram,
  ClickViewing,
  Column,
  Icon,
  New,
  PostingViewing,
  Row,
  Typography,
} from '@viewup/ui';
import { useCheckLogin, useGlobalModalStore } from 'app/_hook';
import { OffViewingModal } from 'app/viewing/_features/click';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

export const ViewingMenus = () => {
  const router = useRouter();
  const { accessToken } = useTokenStore();
  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');
  const checkLogin = useCheckLogin();
  const [isOpenAutoSettingModal, setIsOpenAutoSettingModal] = useState(false);
  // const containerRef = useRef<HTMLElement | null>(null);

  const { data: getViewupAccounts } = useGetViewupSnsAccounts();
  const hasAccounts = (getViewupAccounts?.data?.length || 0) > 0;

  const boxStyles: AllStyledProps = {
    alignItems: 'flex-end',
    bgColor: 'bg.primary',
    br: 12,
    css: {
      cursor: 'pointer',
    },
    flex: '1 1 50%',
    justifyContent: 'space-between',
    p: 16,
    shadow: 'center.normal',
  };

  // useEffect(() => {
  //   containerRef.current = document.getElementById('wrapper');
  // }, []);

  return (
    <Column gap={16} pb={24} pt={16} px={24}>
      <Row gap={16}>
        <Column
          {...boxStyles}
          onClick={() => {
            Analytics.getInstance().track('MAIN_VIEWING_CLICK');
            router.push(LINK.VIEWING_CLICK);
          }}
        >
          <Column alignItems='flex-start' gap={8} width='100%'>
            <Row alignItems='center'>
              <Typography fontType='body.medium'>클릭뷰업</Typography>
              <Icon color='icon.danger' source={New} />
            </Row>
            <Column>
              <Typography color='text.tertiary' fontType='body2.regular'>
                클릭 한번으로
                <br />
                쉽게 적립하기
              </Typography>
            </Column>
          </Column>
          <Icon size='L' source={ClickViewing} />
        </Column>
        <Column
          {...boxStyles}
          onClick={() => {
            Analytics.getInstance().track('MAIN_VIEWING_CLICK_POSTING');
            router.push(LINK.VIEWING_POST_APPLY_LIST);
          }}
        >
          <Column alignItems='flex-start' gap={8} width='100%'>
            <Row alignItems='flex-end' gap={4}>
              <Typography fontType='body.medium'>포스팅 뷰업</Typography>
              <Icon color='icon.danger' source={New} />
            </Row>
            <Column>
              <Typography color='text.tertiary' fontType='body2.regular'>
                블로그 포스팅으로
                <br />
                포인트 적립하기
              </Typography>
            </Column>
          </Column>
          <Icon color='icon.success' size='L' source={PostingViewing} />
        </Column>
      </Row>

      <Row gap={16}>
        <Row
          {...boxStyles}
          onClick={() => {
            Analytics.getInstance().track('MAIN_VIEWING_SETTING_AUTO');
            checkLogin('');
            if (!accessToken) return;
            setIsOpenAutoSettingModal(true);
          }}
        >
          <Column alignItems='flex-start' gap={8} width='100%'>
            <Typography fontType='body.medium'>보너스뷰업</Typography>
            <Typography color='text.tertiary' fontType='body2.regular'>
              매일 쌓이는
            </Typography>
          </Column>
          <Icon size='S' source={AutoViewing} />
        </Row>
        <Row
          {...boxStyles}
          onClick={() => {
            Analytics.getInstance().track('MAIN_VIEWING_CLICK_AUTO');
            if (accessToken && !hasAccounts) {
              setAlertModal({
                actionButtonText: '계정 추가하기',
                content: '오토뷰업으로 설정할 수 있는\n계정이 없어요.',
                onClickActionButton: () => {
                  router.push(LINK.ACCOUNT_ADD);
                },
                title: '계정을 추가해 주세요.',
              });
              return;
            }
            checkLogin(LINK.VIEWING_AUTO_SETTING);
          }}
        >
          <Column alignItems='flex-start' gap={8} width='100%'>
            <Typography fontType='body.medium'>오토뷰업</Typography>
            <Row alignItems='flex-end' justifyContent='space-between' width='100%'>
              <Typography color='text.tertiary' fontType='body2.regular'>
                자동으로 클릭
              </Typography>
            </Row>
          </Column>
          <Icon size='S' source={AutoViewingPictogram} />
        </Row>
      </Row>
      <OffViewingModal
        exitHandler={() => setIsOpenAutoSettingModal(false)}
        isOpen={isOpenAutoSettingModal}
      />
    </Column>
  );
};
